import ManagerPromotion from './ManagerPromotion.container';

export default ManagerPromotion;
